import { Table } from 'antd';
import { calculateColumnsWidth } from 'api';
import {
  getMandateBulkUploadDashboard,
  MandateBulkUploadFilter,
  MandateBulkUploadPagedList,
} from 'api/nach';
import { useState, useEffect } from 'react';
import DashboardFilterListColumn from './DashboardFilterListColumn';
import { LoadingScreen } from 'common/components';

type Props = {
  MandateBulkUploadFilter: MandateBulkUploadFilter;
  onSubmit: (values: MandateBulkUploadFilter) => Promise<void>;
  reloadByTabChange: boolean;
  setOnlyDigitError: (value: boolean) => void;
};
// console.log('mandateBulkUploadFilter in Dashboard filter list ', getMandateBulkUploadDashboard);

let payPagedList: MandateBulkUploadPagedList = { currentPageIndex: 1, noOfRecords: 10, data: [] };

export default function DashboardFilterList({
  MandateBulkUploadFilter: filter,
  reloadByTabChange,
  setOnlyDigitError,
}: Props) {
  const [pagedList, setPagedList] = useState(payPagedList);
  const [isLoading, setIsLoading] = useState(false);

  // Function to fetch the bulk upload dashboard data
  const fetchData = async () => {
    setIsLoading(false);
    try {
      filter.pageNo = 1;
      filter.pageSize = 10;
      // filter.isExtract = false;

      const res = await getMandateBulkUploadDashboard(filter);

      if (res.data && res.data.data) {
        setPagedList(res.data);
        setOnlyDigitError(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(true);
    }
  };

  // Fetch data when the component mounts or when the filter changes
  useEffect(() => {
    fetchData(); // Initial data fetch
  }, [filter]); // Depend on filter to trigger fetch

  // Fetch data on tab change (if reloadByTabChange is true)
  useEffect(() => {
    if (reloadByTabChange) {
      fetchData(); // Trigger data fetch when tab changes
    }
  }, [reloadByTabChange]);
  if (!isLoading) {
    return <LoadingScreen />;
  }
  // Handle changes in the table (pagination, filtering)
  const handleChange = (_pagination: any, _filters: any) => {
    setIsLoading(false);
    // Debugging the pagination and filter changes
    // console.log('Pagination changed: ', _pagination);
    // console.log('Filters applied: ', _filters);

    filter.pageNo = _pagination.current;
    filter.pageSize = _pagination.pageSize;
    getMandateBulkUploadDashboard(filter)
      .then((res) => {
        if (res.data) {
          setPagedList(res.data);
        }
      })
      .finally(() => {
        setIsLoading(true);
      });
  };

  // Calculate the column widths and other table settings dynamically
  const dataTable = calculateColumnsWidth(DashboardFilterListColumn, pagedList.data, 600);
  const tableHeight = 500; // Define the table height
  const rowKey = 'ROWNUM'; // Use this as the unique row identifier in the table

  // Validate that dataTable has valid columns and source before rendering
  if (!dataTable.columns || !dataTable.source) {
    console.error('Table data or columns are missing!');
    return <div>Something went wrong with the table data.</div>;
  }

  return (
    <div>
      <div className="row" style={{ margin: '10px' }}></div>
      <div>
        {/* Table will show even if no data, column headers will be displayed */}
        <Table
          dataSource={pagedList.data.length > 0 ? dataTable.source : []} // Ensure columns are shown even when no data
          columns={dataTable.columns} // The columns to display
          rowKey={rowKey} // Unique row identifier
          scroll={{ x: dataTable.tableWidth, y: tableHeight }} // Table scroll behavior
          onChange={handleChange} // Handle pagination/filter changes
          pagination={{
            pageSize: 10, // Number of rows per page
            total: pagedList.noOfRecords || 0, // Set total number of records (fallback to 0)
            current: pagedList.currentPageIndex || 1, // Set current page index (fallback to 1)
          }}
        />
      </div>
    </div>
  );
}
